import PropTypes from 'prop-types'

export default {
  serialTicket: PropTypes.shape({
    code: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    descriptionNarrow: PropTypes.string.isRequired,
    maxCount: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    nameNarrow: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  }),
  fromTo: {
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired
  },
  plusMinusDesktopProps: PropTypes.shape({
    disabled: PropTypes.bool.isRequired,
    maxValue: PropTypes.number.isRequired,
    onDecreaseClick: PropTypes.func.isRequired,
    onIncreaseClick: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  }),
  plusMinusMobileProps: PropTypes.shape({
    decreaseDisabled: PropTypes.bool.isRequired,
    increaseDisabled: PropTypes.bool.isRequired,
    onDecreaseClick: PropTypes.func.isRequired,
    onIncreaseClick: PropTypes.func.isRequired,
    value: PropTypes.number.isRequired
  }),
  tooltipProps: PropTypes.shape({
    children: PropTypes.node.isRequired,
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })
}
